import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NumberPicker } from '../../../components';
import { ABUtils } from '../../../utils';
import { PaxConstants } from '../../../models';

export const HSASelectorContentRow = ({
    cmsKey,
    min,
    max,
    paxKey,
    onChange,
    value,
    ageCmsKey,
    ageRange,
}) => {
    const { t } = useTranslation();
    const { isCssVariation } = ABUtils.getABs();
    const classRow = classNames({
        'odf-flex-container-row odf-flex-container-nogutter odf-space-outer-bottom-s odf-text-md': !isCssVariation,
        'odf-flex-container-row odf-flex-container-nogutter odf-space-outer-top-m odf-space-outer-bottom-m odf-text-md': isCssVariation,
    });
    return (
        <div className={classRow} data-testid="pax-selector-item">
            <div className="odf-flex-item odf-text-ellipsis">
                <span
                    dangerouslySetInnerHTML={{
                        __html: t(`paxSelector.${cmsKey}.text`),
                    }}
                />
                {paxKey !== PaxConstants.ROOMS && (
                    <span className="odf-space-inner-left-xs">{ageRange}</span>
                )}
            </div>
            <div className="odf-flex-item odf-flex-item-sm">
                <NumberPicker
                    min={min}
                    max={max}
                    value={value}
                    onChange={(val) => onChange({ [paxKey]: val })}
                />
            </div>
        </div>
    );
};

HSASelectorContentRow.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    cmsKey: PropTypes.string.isRequired,
    paxKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    ageCmsKey: PropTypes.string,
};

HSASelectorContentRow.defaultProps = {
    min: 0,
    ageCmsKey: 'paxSelector',
};
